/** English strings. Every key must also exist in ur.ts (enforced by i18n.test.ts). */
export const en = {
  app: {
    name: 'Kharcha',
    product: 'by KCloudAI',
    offline: 'Offline',
    loading: 'Loading…',
    retry: 'Try again',
    error: 'Something went wrong',
    cancel: 'Cancel',
  },
  lang: { switchTo: 'اردو' },
  errors: {
    notFoundTitle: 'Page not found',
    notFoundBody: 'This page doesn’t exist or has moved. Check the address, or go back to the home screen.',
    serverTitle: 'Something went wrong',
    serverBody: 'The server couldn’t finish this request. Please try again in a moment.',
    offlineTitle: 'You’re offline',
    offlineBody: 'This phone has no internet right now. Check Wi-Fi or mobile data, then try again.',
    goHome: 'Go to home',
    goBack: 'Go back',
    tryAgain: 'Try again',
    code: 'Error {{code}}',
    notFoundTip1: 'Check the address for a typing mistake.',
    notFoundTip2: 'Or go back to the home screen and open it from the menu.',
    serverTip1: 'Your saved entries are safe. Nothing was lost.',
    serverTip2: 'Entries not sent yet stay on this phone and send by themselves.',
    serverTip3: 'This is usually fixed in a minute or two.',
    offlineTip1: 'Your saved entries are safe.',
    offlineTip2: 'You can keep adding entries: they wait on this phone.',
    offlineTip3: 'They send by themselves when the internet is back.',
    stillStuck: 'Still not working after a few tries? Write to',
  },
  theme: {
    dark: 'Dark mode',
    light: 'Light mode',
  },
  login: {
    title: 'Sign in',
    subtitle: 'Just your email. We send a code, you type it in, you’re in.',
    pitch: 'Every rupee your shop, office, or home spends, with its receipt, recorded by the person who spent it.',
    point1Title: 'No receipt, no entry.',
    point1Body: 'The photo is saved with the amount, so there’s no "I’ll show you later".',
    point2Title: 'Whoever spends it, records it.',
    point2Body: 'Your office boy, shop helper, or anyone at home, from their phone, the moment they pay.',
    point3Title: 'Every place is a portfolio.',
    point3Body:
      'A house, villa, shop, office, or clinic. Cash in hand and today’s spending for each, on one screen, and you approve from anywhere.',
    point4Title: 'Every change is on record.',
    point4Body: 'Edits, approvals and deletions keep who did it, when and why, so the numbers always add up.',
    productOf: 'A product of',
    sampleLabel: 'This is one entry in Kharcha',
    sampleSpentBy: 'Spent by',
    sampleWho: 'Ali, office helper',
    sampleWhen: 'Today, 11:42 am',
    samplePortfolio: 'Portfolio: Main office',
    sampleItem1: 'Printer paper, 2 reams',
    sampleItem2: 'Tea and sugar',
    sampleItem3: 'Stapler pins, 1 box',
    sampleItem4: 'Drinking water, 20 L',
    sampleTotal: 'Total',
    sampleReceipt: 'Receipt photo attached',
    sampleReceiptBy: 'Taken at the counter, by Ali',
    sampleWaiting: 'Waiting for your review',
    sampleFix: 'Fix',
    sampleReject: 'Reject',
    sampleApprove: 'Approve',
    morningLabel: 'The owner’s morning',
    morningPortfolio: 'Portfolio: Office',
    morningDate: 'Friday 9 Oct',
    morningSpent: 'Spent today',
    morningCash: 'Cash with staff',
    morningReview: 'To review',
    morningReviewCount: '10 slips',
    morningNoReceipt: 'No receipt',
    morningNoReceiptCount: '1 this month',
    morningBilal: 'Bilal',
    morningRecharged: 'recharged yesterday',
    morningHamza: 'Hamza',
    morningNoCash: 'no cash given yet',
    morningApproveAll: 'Approve all under Rs 1,000 with receipt (9)',
    morningGiveCash: 'Give cash',
    noPassword: 'No password to remember or reset.',
    firstTime: 'First time? Same steps. You create your first portfolio right after.',
    workEmail: 'Email',
    change: 'Change',
    digitCode: '6-digit code',
    expiresIn: 'expires in',
    expired5: 'Code expired',
    sentNow: 'Sent to your email just now. Did not get it?',
    noCodeHelp: 'No code? Look in Spam, or tap Send again.',
    notRegistered: 'User not found. For registration, contact',
    paused: 'Your workspace is paused. Contact kharcha@kcloudai.com to open it again.',
    tooMany: 'Too many codes asked for this email. Wait a few minutes and try again.',
    sendAgain: 'Send again',
    sendAgainIn: 'Send again in {{time}}',
    staysPhone: 'Stays signed in for 30 days on this phone.',
    staysBrowser: 'Stays signed in for 30 days on this browser.',
    locationShort: 'Each expense you save records the time and your location. Only the owners can see it.',
    email: 'Email',
    emailPh: 'you@example.com',
    sendCode: 'Email me a code',
    codeTitle: 'Enter the 6-digit code',
    codeSent: 'If this email is registered, a code was sent to {{email}}',
    code: 'Code',
    signIn: 'Sign in',
    resendIn: 'Resend code in {{time}}',
    resend: 'Send a new code',
    differentEmail: 'Different email',
    wrongCode: 'Wrong code. Try again.',
    expired: 'This code has expired or was tried too many times. Request a new one.',
    autofill: 'The code fills in by itself when you paste it. It works for 5 minutes.',
    locationTitle: 'Location is saved with each entry',
    locationBody: 'When you save an expense, the phone’s location is stored with it. Only the owners can see it.',
    ok: 'OK',
  },
  home: {
    hello: 'Assalam o Alaikum',
    cashWithYou: 'Cash with you · tap a card',
    low: 'Low — ask for cash',
    recharge: '{{name}} gave you <b>{{amount}}</b> for {{entity}}',
    received: 'Received',
    receivedDone: 'Thanks — marked as received',
    waiting_one: '{{count}} entry waiting to send',
    waiting_other: '{{count}} entries waiting to send',
    spentToday: 'Spent today',
    entries_one: '{{count}} entry',
    entries_other: '{{count}} entries',
    history: 'History',
    add: 'Add expense',
    addFor: '{{entity}}: add an expense or give cash',
    arrangeReset: 'Reset order',
    holdToMove: 'Hold and drag to move it. Alt + arrow keys also move it.',
    dropHint: 'Drag to a new place and let go',
    logout: 'Log out',
    logoutTitle: 'Log out?',
    ownerApp: 'Owner app',
    logoutBody: 'You will need a new code from your email to sign in again.',
  },
  give: {
    chooseTitle: 'What do you want to do?',
    inHandOf: '{{entity}} · in hand {{amount}}',
    chooseAdd: 'Add expense',
    chooseAddSub: 'Something you bought',
    chooseGive: 'Give cash',
    chooseGiveSub: 'Hand some of this cash to another spender',
    title: 'Give cash',
    intro: 'Hand part of your cash to another spender. It leaves your wallet now; they tap Received on their phone.',
    from: 'Whose money',
    inHand: 'In hand: {{amount}}',
    to: 'Give to',
    nobody: 'No one else spends for {{entity}}.',
    choose: 'Choose a person…',
    amount: 'Amount',
    note: 'Note (optional)',
    notePlaceholder: 'e.g. For the office groceries',
    submit: 'Give {{amount}} to {{name}}',
    submitEmpty: 'Give cash',
    tooMuch: 'You have {{amount}} in hand',
    done: 'Gave {{amount}} to {{name}}',
    undo: 'Undo',
    undone: 'Undone: the cash is back in your wallet',
    recent: 'Cash you gave',
    waiting: 'Waiting for them to accept',
    accepted: 'Accepted',
    none: 'Nothing given yet.',
    back: 'Back',
  },
  add: {
    close: 'Close',
    backHome: 'Back to home',
    back: 'Back',
    whoseMoney: 'Whose money?',
    ownerSays: 'Owner says',
    whatTitle: 'What did you buy?',
    usual: 'Usual buys — one tap fills everything',
    orType: 'Or pick a type',
    usualShort: 'Usual buys',
    moreTypes: 'Show {{count}} more',
    holdToMoveType: 'Hold and drag to rearrange',
    more: 'More',
    less: 'Less',
    itemTitle: 'Which item?',
    newName: 'New item name',
    newPh: 'Type the name',
    use: 'Use',
    noHistory: 'Nothing bought in this type yet. Type the name below.',
    amountTitle: 'How much did you pay?',
    quantity: 'Quantity',
    qtyTitle: 'How much did you buy?',
    qtyPh: 'Quantity',
    unit: 'Unit',
    amountPaid: 'Amount paid',
    amountPh: 'Enter amount',
    needQty: 'Enter the quantity',
    needUnit: 'Pick a unit (pcs, kg, L…)',
    needAmount: 'Enter the amount you paid',
    sameAsLast: 'Same as last time',
    next: 'Next',
    leftAfter: 'Left after',
    notEnough: 'Not enough cash',
    proofTitle: 'Receipt photo',
    takePhoto: 'Take photo',
    fromGallery: 'From gallery',
    addFromGallery: 'Add a photo from the gallery',
    addAnother: 'Add another',
    addPhoto: 'Add another photo',
    removePhoto: 'Remove photo',
    photoAdded: 'Photo added',
    preparing: 'Preparing photo…',
    noReceipt: 'No receipt?',
    receiptTitle: 'Add the receipt',
    receiptHint: 'The shop name, items and total should be readable.',
    whyNoReceipt: 'Why no receipt?',
    backToPhoto: 'Photo',
    reasonShop: 'Shop gives no slip',
    reasonStreet: 'Street vendor',
    reasonLost: 'Slip lost',
    reasonOther: 'Other',
    otherPh: 'Write the reason (5+ letters)',
    ownerWillCheck: 'The owner will check this entry',
    when: 'When?',
    otherDate: 'Other date',
    pickDate: 'Pick the date',
    prevMonth: 'Previous month',
    nextMonth: 'Next month',
    sameDay_one: 'Already saved for {{date}}: {{count}} entry · {{amount}}',
    sameDay_other: 'Already saved for {{date}}: {{count}} entries · {{amount}}',
    save: 'Save',
    saving: 'Saving…',
    hintPhoto: 'Take a photo of the receipt to save',
    hintReason: 'Pick a reason to save',
    hintOther: 'Write at least 5 letters',
    dupTitle: 'Looks like a duplicate',
    dupBody: 'You saved the same amount for this type a few minutes ago. Save it again?',
    dupBack: 'Go back and check',
    dupSave: 'Save anyway',
    discardTitle: 'Leave without saving?',
    discardBody: 'What you filled in will be lost.',
    keepFilling: 'Keep filling',
    leave: 'Leave',
    itemPlaceholder: 'What did you buy?',
    noPhotoYet: 'No photo yet',
    photos_one: '{{count}} photo',
    photos_other: '{{count}} photos',
    noReceiptShort: 'No receipt',
    lastBought: 'Last bought {{ago}} — {{what}}, {{amount}} by {{who}}',
    step: '{{n}} / 3',
    whoPaid: 'Paid By',
  },
  gps: {
    checking: 'Finding your location…',
    why: 'Purchases are saved with the place they were made, when location is on.',
    retry: 'Retry',
    turnOn: 'Turn on location',
    skip: 'Continue without location',
    skipNote: 'You can still use your wallet. Purchases are then saved without a place.',
    insecureTitle: 'Location can’t work on this link',
    insecureBody: 'Open Kharcha from its https:// link (the one the owner sent). Phones only share their location with secure pages.',
    unsupportedTitle: 'This phone can’t share its location',
    unsupportedBody: 'Update the browser (Chrome), or use a phone that has location (GPS).',
    deniedTitle: 'Allow location for Kharcha',
    deniedBody: 'Tap the lock or ⓘ next to the web address, then Permissions → Location → Allow. Then tap Retry.',
    offTitle: 'Turn on location (GPS)',
    offBody: 'Tap Turn on location (or swipe down from the top of the screen and turn on Location), then come back.',
    timeoutTitle: 'Couldn’t find your location',
    timeoutBody: 'Check that Location is on, go near a window or outside, then tap Retry.',
    weakTitle: 'Location signal is too weak',
    weakBody: 'Turn on Location with high accuracy, go near a window or outside, then tap Retry.',
  },
  saved: {
    title: 'Saved',
    spent: 'Spent',
    receiptLabel: 'Receipt',
    statusLabel: 'Status',
    balanceNow: '{{entity}} · balance now',
    queued: 'Saved on phone — will send when online',
    sent: 'Sent to the owner',
    another: 'Add another for {{entity}}',
    undo: 'Undo · {{seconds}}',
    done: 'Done',
  },
  history: {
    title: 'History',
    thisWeek: 'This week',
    all: 'All',
    needsFix: 'Needs fix',
    notSent: 'Not sent',
    photo: 'Receipt photo',
    photoOf: 'Photo {{n}} of {{count}}',
    photoPrev: 'Previous photo',
    photoNext: 'Next photo',
    photoFailed: 'The photo could not be loaded.',
    photoOffline: 'Photos need the internet.',
    filterStatus: 'Status',
    filterPlace: '{{Place}}',
    allPlaces: 'All places',
    clearFilters: 'Show all',
    noMatch: 'No entries match these filters.',
    tapToFix: 'Tap to fix',
    tapToReply: 'Tap to reply or fix',
    messages: 'Messages',
    ownerNeedsFix: 'Needs fix',
    ownerRejected: 'Rejected',
    owner: 'Owner',
    you: 'You',
    replyLabel: 'Your reply to the owner',
    replyHint: 'e.g. The shop did not give a receipt',
    sendReply: 'Send reply',
    sending: 'Sending…',
    replyShort: 'Write at least 2 letters.',
    replyOffline: 'Sending a reply needs the internet. Try again when you are online.',
    replyFailed: 'The reply could not be sent. Try again.',
    replySent: 'Reply sent. The owner will check the entry again.',
    orFix: 'Or change the entry itself:',
    fixEntry: 'Fix the entry',
    nothing: 'Nothing here.',
    earlier: 'Earlier',
    edit: 'Edit',
    delete: 'Delete',
    deleteTitle: 'Delete this entry?',
    deleteConfirm: '{{amount}} goes back to your {{entity}} balance.',
    paidBy: 'Paid by {{name}}',
    paidByOther: 'Another {{place}} paid',
  },
  notes: {
    title: 'Notifications',
    bellUnread_one: 'Notifications, {{count}} unread',
    bellUnread_other: 'Notifications, {{count}} unread',
    unread_one: '{{count}} new',
    unread_other: '{{count}} new',
    new: 'New',
    markAll: 'Mark all read',
    empty: 'No notifications yet',
    emptyHint: 'You will be told here when the owner sends you a message or gives you cash.',
    failed: 'Could not load notifications.',
    from: 'From {{name}}',
    kind: {
      needs_fix: 'Sent back: needs fix',
      rejected: 'Rejected by the owner',
      cash_in: 'Cash given to you',
    },
  },
  status: {
    pending: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected',
    needs_correction: 'Needs fix',
    queued: 'Not sent',
    failed: 'Not sent — tap to fix',
  },
  ago: {
    today: 'today',
    yesterday: 'yesterday',
    days_one: '{{count}} day ago',
    days_other: '{{count}} days ago',
  },
  day: { today: 'Today', yesterday: 'Yesterday', tomorrow: 'Tomorrow' },
  units: { pcs: 'pcs', kg: 'kg', g: 'g', L: 'L', ml: 'ml', dozen: 'dozen', pack: 'pack', bunch: 'bunch' },
  /** Short tile labels for the seeded categories, by icon key. Unknown keys show the DB name. */
  cat: {
    veg: 'Vegetables',
    fruit: 'Fruits',
    meat: 'Meat',
    rice: 'Rice & flour',
    dairy: 'Milk & eggs',
    oil: 'Oil & spice',
    water: 'Water',
    kitchen: 'Kitchen items',
    clean: 'Cleaning',
    washroom: 'Washroom',
    stationery: 'Stationery',
    printing: 'Printing',
    petrol: 'Petrol',
    generator: 'Generator',
    electricity: 'Electricity',
    gas: 'Gas',
    phone: 'Phone',
    internet: 'Internet',
    repair: 'Repairs',
    plumbing: 'Plumbing',
    furniture: 'Furniture',
    misc: 'Other',
  },
} as const;

type Widen<T> = { -readonly [K in keyof T]: T[K] extends string ? string : Widen<T[K]> };
export type Strings = Widen<typeof en>;
